import { gql } from '@apollo/client'

export const CREATE_CENTER_DOCUMENT = gql`
  mutation createCenterDocument($document: InputCenterDocument!) {
    createCenterDocument(document: $document) {
      id
      name
      document_type
      content_type
      sf_account_ids
      file {
        url
      }
      created_at
      updated_at
      user {
        id
        email
        firstname
        lastname
      }
    }
  }
`

export const UPDATE_CENTER_DOCUMENT = gql`
  mutation updateCenterDocument($id: ID!, $document: InputUpdateCenterDocument!) {
    updateCenterDocument(id: $id, document: $document) {
      id
      name
      document_type
      content_type
      sf_account_ids
      file {
        url
      }
      created_at
      updated_at
      user {
        id
        email
        firstname
        lastname
      }
    }
  }
`

export const REMOVE_CENTER_DOCUMENT = gql`
  mutation removeCenterDocument($id: ID!) {
    removeCenterDocument(id: $id) {
      status
    }
  }
`